export default __webpack_public_path__ + "static/media/pattern_topography.12feec03.png";